<template>
  <!-- 订舱 -->
  <div class="Booking">
    <TopNavigation class="topNavigation"></TopNavigation>
    <div class="typeArea">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Template' }"
          >模板中心</el-breadcrumb-item
        >
        <el-breadcrumb-item class="bread">{{canshu.title}}模板</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="mobanmingc">
        <div class="form-tit"><span>*</span>模板名称</div>
        <el-input v-model="form.template_name" placeholder="请输入"></el-input>
      </div>

      <div class="mobancon">
        <!-- 海关编号 -->
        <div class="customs">
          <div class="title">HS(海关编号)</div>
          <div class="form-tit"><span>*</span>HS(海关编号：仅限六位数字)</div>
          <div class="input">
            <div
              class="yi"
              v-for="(item, index) in inputList"
              :key="index"
              :class="(index + 1) % 4 == 0 ? 'yi2' : 'yi'"
            >
              <el-input  @blur="hsBlus" v-model="item.text" placeholder="请输入"></el-input>
              <i @click="removeRow(index)" class="el-icon-delete"></i>
            </div>
          </div>
          <div class="add" @click="addRow">
            <i class="el-icon-circle-plus-outline"></i>
            <div>新增HS</div>
          </div>
        </div>

        <!-- 箱型 -->
        <div class="boxType">
          <div class="title">选择箱型箱量</div>
          <!-- <div class="boxNum">
            <div class="box-yi" v-for="(item,index) in form.boxtype" :key="index">
              <div class="box-tit"><span>*</span>{{item.box_type}}</div>
              <el-input-number
                v-model="item.number"
                @change="handleChange"
                :min="0"
              ></el-input-number>
            </div>
          </div> -->
          <div class="box-c" v-for="(item, index) in form.boxtype" :key="index">
            <div class="box-con">
                <el-select @change="changeBox" class="ronmg" v-model="item.box_type" placeholder="请选择">
                  <el-option
                  :disabled="it.isDisabled"
                  v-for="(it,idx) in boxTypeList"
                  :key="idx"
                  :label="it.name"
                  :value="it.name">
                </el-option>
                </el-select>
                <div class="line"></div>
                <div class="nei ronmg">
                    <span>箱重</span>
                    <!-- 验证单箱重量，超过最大货重不允许下单 -->
                    <el-input  @change="changeBoxtotleweight(index)" v-model="item.weight" min='0' type="number" placeholder="请输入"></el-input>
                </div>
            </div>
            <i 
            class="el-icon-delete"
            @click="removeBox(index)" 
            ></i>
          </div>

          <div class="add" @click="addBox">
            <i class="el-icon-circle-plus-outline"></i>
            <div>新增箱型</div>
          </div>
        </div>

        <!-- 货物信息 -->
        <div class="CargoInformation">
          <div class="title">货物信息</div>

          <div class="info-shang">
            <div>
              <div class="word"><span>*</span>包装单位</div>
              <el-select v-model="form.packing_unit" placeholder="请选择">
                <el-option
                  v-for="item in packingList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <div class="word"><span>*</span>件数</div>
              <el-input
                min='0' type="number"
                @blur="onBlur"
                v-model="form.quantity"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>总货重(kgs)</div>
              <el-input
                readonly
                @blur="onBlur"
                v-model="form.totle_weight"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>体积(cbm)</div>
              <el-input
                min='0' type="number"
                @blur="onBlur"
                v-model="form.totle_volume"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>

          <div class="info-shang">
            
            <div>
              <div class="word"><span>*</span>唛头</div>
              <el-input
                type="textarea"
                v-model="form.shipping_mark"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>货物描述</div>
              <el-input
                type="textarea"
                v-model="form.describe"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>
        </div>

        <!-- 收发通 -->
        <div class="CargoInformation shoufat">
          <div class="title">收发通</div>
          <div class="info-shang info-shoufat">
            <div>
              <div class="word"><span>*</span>发货人</div>
              <el-input
                type="textarea"
                v-model="form.shipper"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>收货人</div>
              <el-input
                type="textarea"
                v-model="form.consignee"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>通知人</div>
              <el-input
                type="textarea"
                v-model="form.notifier"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>
        </div>

        <!-- 订舱联系人 -->
        <div class="CargoInformation phone-info">
          <div class="title">订舱联系人</div>

          <div class="info-shang">
            <div class="yi1">
              <div class="word">订舱联系人</div>
              <el-input v-model="form.linkman" placeholder="请输入"></el-input>
              <!-- <el-select v-model="form.linkman" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select> -->
            </div>
            <div class="yi1">
              <div class="word">联系人电话</div>
              <el-input
                @blur="validDianhua"
                v-model="form.linkman_phone"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div
              class="yi"
              v-for="(item, index) in emailList"
              :key="index"
              :class="(index + 3) % 4 == 0 ? 'yi2' : 'yi'"
            >
              <div class="word"><span>*</span>联系人邮箱</div>
              <div class="ipt_del">
                <el-input @blur="validEmsil" v-model="item.email" placeholder="请输入"></el-input>
                <div @click="removeEmail(index)" class="delete">删除</div>
              </div>
            </div>
          </div>

          <div class="add" @click="addEmail">
            <i class="el-icon-circle-plus-outline"></i>
            <div>新增联系人邮箱</div>
          </div>

          <!-- 上传 -->

          <div class="update">
            <div class="title">上传附件</div>
            <div class="shangchuan">
              <div class="word">上传附件</div>
              <div class="btn">
                <!-- action  上传地址 -->
                <div>
                  <el-upload
                    class="upload-demo"
                    action="https://serve.dhcang.com/api/upload/file"
                    :on-success="fujianSuccess"
                    multiple
                    :headers="headers"
                    :show-file-list="false"
                  >
                    <el-button class="sc_btn" size="small" type="primary"
                      >上传附件</el-button
                    >
                  </el-upload>
                  <div
                    class="updateList"
                    v-for="(item, index) in fujianFileList"
                    :key="index"
                  >
                    <i class="el-icon-success"></i>
                    <div class="name">{{ item.file_name }}</div>
                    <el-button @click="download(item)" class="el-butnm del" type="text">下载</el-button>
                    <el-button
                      @click="fujianRemove(index)"
                      class="el-butnm"
                      type="text"
                      >删除</el-button
                    >
                  </div>
                </div>
                <!-- <div>
                  <el-upload
                    class="upload-demo"
                    action="https://serve.dhcang.com/api/upload/file"
                    multiple
                    :on-success="weituoshuSuccess"
                    :headers="headers"
                    :show-file-list="false"
                  >
                    <el-button class="sc_btn" size="small" type="primary"
                      >上传委托书</el-button
                    >
                  </el-upload>
                  <div
                    class="updateList"
                    v-for="(item, index) in weituoshuFileList"
                    :key="index"
                  >
                    <i class="el-icon-success"></i>
                    <div class="name">{{ item.file_name }}</div>
                    <el-button class="el-butnm del" @click="download(item)" type="text">下载</el-button>
                    <el-button
                      @click="weituoshuRemove(index)"
                      class="el-butnm"
                      type="text"
                      >删除</el-button
                    >
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <div class="info-shang info_phone">
            <div class="title">订单备注</div>
            <div>
              <div class="word">备注信息</div>
              <el-input
                type="textarea"
                v-model="form.remarks"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>
        </div>

        <div class="button">
          <el-button class="quxiao" @click="$router.push('/Template')"
            >取消</el-button
          >
          <el-button class="dingcanggg" @click="submit">保存</el-button>
        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>
     
  <script>
import Bottom from "../HP/BottomPage.vue";
import TopNavigation from "../HP/TopNavigationB.vue";
import { userTemplateAdd,dict,userTemplateDetail,userTemplateEdit,baseCasesGaugeTypeValidList } from "@/api/api";
export default {
  components: {
    Bottom,
    TopNavigation,
  },
  data() {
    return {
      inputList: [{ text: "" }],
      emailList: [{ email: "" }],
      // 上传文件列表
      fujianFileList: [],
      weituoshuFileList: [],
      // 表单数据
      form: {
        type: 1, // 模板类型：1精选运价、2现舱市场
        template_name: "", // 模板名称
        packing_unit: "", // 包装单位
        quantity: "", // 件数
        totle_weight: "", // 总货重（kgs）
        totle_volume: "", // 体积（cbm）
        describe: "", // 货物描述
        shipping_mark: "", // 唛头
        linkman: "", // 订舱联系人
        linkman_phone: "", // 订舱联系人电话
        shipper: "", // 发货人信息
        consignee: "", // 收货人信息
        notifier: "", // 通知人信息
        remarks: "", // 备注
        hs: [], // HS海关编码，如：["编码一","编码二"]
        boxtype: [{
              box_type:'',
              weight:'',
              number:1,
          }], // 箱型箱量，如：[{"box_type":"箱型，如：20GP","number":"数量"}]
        email: [], // 订舱联系人邮箱，如：["邮箱一","邮箱二"]
        files: [
          // {type:1,file_name:'',file_url:'',file_type:''},
          // {type:2,file_name:'',file_url:'',file_type:''},
        ], // 附件，如：[{"type":"文件类型：1订单附件、2订单委托书","file_name":"文件名称","file_url":"文件地址","file_type":"文件类型：image、pdf、word等"}]
      },
      headers: {
        token: localStorage.getItem("token"),
      },
      // {box_type:'20GP',number:0,money:"100",dead_freight:"3",box_no:""},
      // {box_type:'40GP',number:0,money:"200",dead_freight:"3",box_no:""},
      // {box_type:'40HQ',number:0,money:"300",dead_freight:"3",box_no:""},
      boxTypeList:[],
      // 包装单位列表
      packingList:[],
      // 接收参数，
      canshu:{},
    };
  },
  methods: {
    addRow() {
      this.inputList.push({ text: "" }); // 添加新行
    },
    removeRow(index) {
      this.inputList.splice(index, 1); // 删除指定行
    },
    addEmail() {
      this.emailList.push({ email: "" }); // 添加新行
    },
    removeEmail(index) {
      this.emailList.splice(index, 1); // 删除指定行
    },
    addBox() {
      this.form.boxtype.push(
        {
          box_type:'',
            weight:'',
            number:1,
        }
      ); // 添加箱型
    },
    removeBox(index) {
      if(this.form.boxtype.length==1){
          this.$message({
              type:'error',
              message:'最少要填写一个'
          })
          return
      }
      this.form.boxtype.splice(index, 1); // 删除箱型
    },
    handleChange(value) {
      console.log(value);
    },
    // 总货重
    changeBoxtotleweight(){
      this.form.totle_weight = 0
      for (let i = 0; i < this.form.boxtype.length; i++) {
        this.form.totle_weight += Number(this.form.boxtype[i].weight)
      }
    },
    // 文件上传
    fujianSuccess(res) {
      if(this.fujianFileList.length==10){
        this.fujianFileList.splice(0, 1);
      }
      this.fujianFileList.push({
        type:1,
        file_name:res.data.name,
        file_url:res.data.url,
        file_type:res.data.type
      })
    },
    fujianRemove(index){
      this.fujianFileList.splice(index, 1);
    },
    weituoshuSuccess(res) {
      if(this.weituoshuFileList.length==1){
        this.weituoshuFileList.splice(0, 1);
      }
      // this.weituoshuFileList.push(res.data)
      this.weituoshuFileList.push({
        type:2,
        file_name:res.data.name,
        file_url:res.data.url,
        file_type:res.data.type
      })
    },
    weituoshuRemove(index){
      this.weituoshuFileList.splice(index, 1);
    },
    // 提交
    async submit() {
      this.form.hs=[]
      for (let i = 0; i < this.inputList.length; i++) {
        this.form.hs.push(Number(this.inputList[i].text))
      }

      this.form.email=[]
      for (let i = 0; i < this.emailList.length; i++) {
        this.form.email.push(this.emailList[i].email)
      }

      this.form.files=[]
      // 订单附件
      for (let i = 0; i < this.fujianFileList.length; i++) {
        this.form.files.push({
          type:1,
          file_name:this.fujianFileList[i].file_name,
          file_url:this.fujianFileList[i].file_url,
          file_type:this.fujianFileList[i].file_type
        })
      }
      // 委托书
      for (let i = 0; i < this.weituoshuFileList.length; i++) {
        this.form.files.push({
          type:2,
          file_name:this.weituoshuFileList[i].file_name,
          file_url:this.weituoshuFileList[i].file_url,
          file_type:this.weituoshuFileList[i].file_type
        })
      }

      try {
        if(this.canshu.title=='新建'){
          const res = await userTemplateAdd(this.form,this.headers)
          if (res.code==1) {
            this.$message({
              type:'success',
              message:"保存成功"
            })
            this.$router.push('/Template')
          }else{
            this.$message({
              type:'error',
              message:res.msg
            })
          }
        }else if(this.canshu.title=='编辑'){
          const res = await userTemplateEdit(this.form,this.headers)
          if (res.code==1) {
            this.$message({
              type:'success',
              message:"保存成功"
            })
            this.$router.push('/Template')
          }else{
            this.$message({
              type:'error',
              message:res.msg
            })
          }
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 获取包装单位
    async getPacking(){
      try {
        const res = await dict({
          type:'packing_unit'
        },this.headers)
        if (res.code==1) {
          this.packingList=res.data.packing_unit
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    changeBox(){
        this.boxTypeList.forEach(v => {
          v.isDisabled = false
          for (var i = 0; i < this.form.boxtype.length; i++) {
            if (this.form.boxtype[i].box_type == v.name) {
              v.isDisabled = true
            }
          }
        })
      },
    // 箱型
    async getBoxTypeList() {
      // 目的港列表
      const res = await baseCasesGaugeTypeValidList();
      if (res.code == 1) {
        this.boxTypeList = res.data;

        for (let i = 0; i < this.boxTypeList.length; i++) {
          this.boxTypeList[i].isDisabled = false
        }
      }
    },
    // 编辑
    async getDetail(){
      try {
        const res = await userTemplateDetail({
          id:this.canshu.id
        },this.headers)
        if (res.code==1) {
          this.form = res.data

          this.inputList=[]
          for (let i = 0; i < res.data.hs.length; i++) {
              this.inputList.push({'text':res.data.hs[i]})
          }

          this.emailList=[]
          for (let i = 0; i < res.data.email.length; i++) {
              this.emailList.push({'email':res.data.email[i]})
          }

          this.fujianFileList = []
          this.weituoshuFileList = []

          for (let i = 0; i < res.data.files.length; i++) {
            if(res.data.files[i].type==1){
              this.fujianFileList.push(res.data.files[i])
            }else if(res.data.files[i].type==2){
              this.weituoshuFileList.push(res.data.files[i])
            }
          }

          this.changeBox()

        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 文件下载
    download(e) {
        const link = document.createElement('a');
        link.href = e.file_url;
        link.setAttribute('download', '');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    // 校验邮箱
    validEmsil(e) {
      let emial = e.target.value
      if(emial==''){
        return
      }
      if (emial == "" || emial == undefined) {
        this.$message({
          message: "请输入邮箱地址",
          type: "error",
        });
        return false;
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          emial
        )
      ) {
        this.$message({
          // duration:0,
          message: "请输入正确的邮箱地址",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 校验手机号
    validDianhua() {
      let dianhua = this.form.linkman_phone
      if(dianhua==''){
        return
      }
      if (!/^1[3-9]\d{9}$/.test(dianhua)) {
        // this.$toast('请输入正确的手机号')
        // alert('1121')
        // this.$message.error("请输入正确的手机号");
        this.$message({
          // duration:0,
          message: "请输入正确的手机号",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 输入的数字大于0
    onBlur(e){
     if(e.target.value == ''){
        return
      }
      if(!/\d$/.test(e.target.value)){
        this.$message({
          type:'error',
          message:'输入的内容应为数字'
        })
      }
    },
    hsBlus(e){
      if(e.target.value == ''){
          return
        }
      if(!/^[1-9]\d{5}$/.test(e.target.value)){
        this.$message({
          type:'error',
          message:'输入的内容应为六位数字'
        })
      }
    }
  },
  mounted(){
    this.canshu = this.$route.params
    if (this.canshu.title=='编辑') {
      this.getDetail()
    }
    this.getPacking()
    this.getBoxTypeList()
  }
};
</script>
  
  <style style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  // background: #Fff;
}

.Booking {
  background: #f9f9f9;
}
.mobancon {
  background: #fff;
  // background: pink;
  padding: 32px;
  box-sizing: border-box;
  margin-bottom: 24px;
  border-radius: 12px;
}
.typeArea {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.el-breadcrumb {
  margin: 20px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .el-breadcrumb__inner is-link {
    color: pink;
  }
}

:deep(.el-breadcrumb) {
  .el-breadcrumb__inner {
    color: #999999 !important;
  }
  .bread {
    span {
      color: #0073f5 !important;
    }
  }
}

.template {
  height: 122px;
  // background: #FfFFFF;
  border-radius: 12px 12px 12px 12px;
  margin-bottom: 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #999999;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .shiyopng {
      color: #0073f5;
      font-size: 20px;
      margin-bottom: 8px;

      .wode {
        margin-left: 9px;
        display: inline-block;
        width: 80px;
        height: 28px;
        background: #edf6ff;
        border-radius: 4px 4px 4px 4px;

        font-size: 14px;

        text-align: center;
        line-height: 28px;
      }
    }
  }

  .right {
    height: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    cursor: pointer;
  }
}

.info {
  height: 297px;
  // background: #FfFFFF;
  border-radius: 12px 12px 12px 12px;

  margin-bottom: 20px;
}

.shang {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 164px;
  border-bottom: #eee solid 1px;
  .logo {
    width: 48px;
    height: 48px;
    margin-right: 120px;
  }
  .qiyun {
    // width: 120px;
    .date {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin-bottom: 4px;
    }
    .address {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      font-style: normal;
      text-transform: none;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .dao {
    width: 100px;
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #999999;
    font-style: normal;
    text-transform: none;

    margin: 0 48px;
    img {
      width: 100px;
      height: 7px;
    }
    div {
      height: 12px;
    }
  }
}

.zhong {
  display: flex;

  margin-top: 24px;
  margin-bottom: 12px;

  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  div {
    margin-right: 48px;
  }
  .kuan {
    width: 130px;
  }
}

.xia {
  display: flex;

  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  .kuan {
    width: 130px;
    margin-right: 48px;

    display: flex;
  }

  .kuan:nth-child(2) {
    width: 132px;
    margin-right: 42px;
  }
  .cilick {
    cursor: pointer;
    color: #0073f5;
  }
}

.customs {
  // height: 217px;
  // background: #FfFFFF;
  border-radius: 12px 12px 12px 12px;

  margin-bottom: 20px;

  .title {
    width: 109px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;
    margin-top: 12px;
  }

  .form-tit {
    // width: 92px;
    height: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #606260;
    font-style: normal;
    text-transform: none;

    margin-top: 24px;
    margin-bottom: 12px;

    span {
      color: #fe3300;
    }
  }

  .input {
    display: flex;
    flex-wrap: wrap;
    .yi {
      display: flex;
      align-items: center;
      margin-right: 24px;
      margin-bottom: 20px;
    }

    .yi2 {
      display: flex;
      align-items: center;
      margin-right: 24px;
      margin-right: 0px;
      margin-bottom: 20px;
    }

    :deep(.el-input) {
      width: 242px;
      input {
        width: 242px;
        height: 44px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }

    .el-icon-delete {
      color: #606260;
      margin-left: 8px;
      cursor: pointer;

      font-size: 16px;
    }
  }

  .add {
    width: 120px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #0073f5;
    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
    i {
      margin-right: 4px;
      font-size: 16px;
    }
  }
}

.boxType {
  // height: 218px;
  // background: #FfFFFF;
  // border-radius: 12px 12px 12px 12px;

  margin-bottom: 20px;
  .title {
    width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 32px;
  }

  .boxNum {
    margin-top: 24px;

    display: flex;
    .box-yi {
      margin-right: 24px;
      .box-tit {
        margin-bottom: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        font-style: normal;
        text-transform: none;
        color: #606260;
        span {
          color: #fe3300;
        }
      }

      .el-input-number {
        width: 242px;
        height: 44px;
      }

      .qian {
        margin-top: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #606260;
        font-style: normal;
        text-transform: none;

        display: flex;
        div {
          margin-right: 16px;
        }
      }
    }
  }

  .add{
    margin-top: 24px;
    color: #0073F5;
    font-size: 14px;
    cursor: pointer;
    width: 120px;
    display: flex;
    align-items: center;
    i{
      margin-right: 4px;
      font-size: 16px;
    }
  }

  .el-icon-delete{
    color: #606260;
    cursor: pointer;
    margin-left: 8px;
  }
}

.CargoInformation {
  // height: 401px;
  // background: #FfFFFF;
  // border-radius: 12px 12px 12px 12px;

  margin-bottom: 20px;

  .title {
    width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 32px;
  }

  .info-shang {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;

    .word {
      margin-bottom: 12px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      font-style: normal;
      text-transform: none;
      color: #606260;
      span {
        color: #fe3300;
      }
    }
    :deep(.el-input) {
      input {
        width: 266px;
        height: 44px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 556px;
        height: 160px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }
  }

  .info-shoufat {
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 362px;
      }
    }
  }
}

.shoufat {
  :deep(.el-textarea) {
    .el-textarea__inner {
      width: 362px;
    }
  }
}

.phone-info {
  height: 100%;
  .info-shang {
    flex-wrap: wrap;
    justify-content: start;

    .yi1 {
      margin-right: 24px;
    }
    .yi {
      margin-bottom: 20px;
      margin-right: 24px;

      :deep(.el-input) {
        width: 226px;
        input {
          width: 226px;
          height: 44px;
          background: #f9f9f9;
          border-radius: 8px 8px 8px 8px;
          border: 0;
        }
      }
    }
    .yi2 {
      margin-right: 0px;
    }
    .delete {
      margin-right: 4px;
      font-size: 16px;

      cursor: pointer;

      font-size: 14px;
      color: #fe3300;

      line-height: 44px;
    }

    .ipt_del {
      display: flex;
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
    }
  }
  .add {
    width: 120px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #0073f5;
    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
  }

  .info_phone {
    .word {
      margin-top: 24px;
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 1136px;
      }
    }
  }
}

.update {
  .title {
    margin-top: 24px;
    margin-bottom: 24px;
    margin-top: 32px;
  }
  .shangchuan {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
  }

  .btn {
    display: flex;
    margin-top: 12px;
    .sc_btn {
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      color: #0073f5;
      font-size: 14px;
      border: 0;
    }
  }

  .upload-demo {
    width: 266px;
    margin-right: 24px;
  }

  .updateList {
    // margin-top: 12px;

    display: flex;
    align-items: baseline;

    i {
      font-size: 16px;
      color: #00b53c;
      margin-right: 9px;
    }

    .name {
      width: 130px;

      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #0073f5;
      font-style: normal;
      text-transform: none;
    }

    .el-butnm {
      color: #fe3300;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      font-style: normal;
      text-transform: none;

      height: 24px;
    }

    .del {
      color: #0073f5;
      margin-left: 53px;
    }
  }
}

.button {
  text-align: center;
  margin-top: 48px;
  .quxiao {
    width: 100px;
    height: 40px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    border: 0;
    color: #999999;
    font-size: 14px;
    margin-right: 16px;
  }

  .dingcanggg {
    width: 100px;
    height: 40px;
    background: #0073f5;
    border-radius: 8px 8px 8px 8px;
    color: #fff;
    border: 0;
    font-size: 14px;
    margin-right: 32px;
  }
}
.mobanmingc {
  height: 140px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  margin-bottom: 20px;
  padding: 32px;
  box-sizing: border-box;

  .form-tit {
    width: 92px;
    height: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #606260;
    font-style: normal;
    text-transform: none;

    margin-bottom: 12px;

    span {
      color: #fe3300;
    }
  }
  :deep(.el-input) {
    width: 242px;
    input {
      width: 242px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
    }
  }
}

.box-c,.box-con,.nei{
    display: flex;
    align-items: center;
}

.box-c{
    margin-bottom: 24px;
}

.box-con{
    // width: 578px;
    height: 48px;
    background: #F9F9F9;
    border-radius: 8px 8px 8px 8px;
    .line{
        width: 1px;
        height: 24px;
        // background: red;
        background: #EEEEEE;
    }
    .ronmg{
        width: 160px;
        margin: 0 16px;
        :deep(.el-input){
            input{
                color: #333333;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;
                border: 0;
                padding: 0;
            }
        }
    }

    .nei{
        span{
            width: 40px;
            display: inline-block;
            font-size: 14px;
            margin-right: 4px;
        }
    }
}
</style>